export const SUCCESSFUL_SUBMIT_MODAL = 'successfulSubmitModal'
